// extracted by mini-css-extract-plugin
export default {"title":"bsci-info_title__rxXKa","subTilte":"bsci-info_subTilte__hzXcb","list":"bsci-info_list__WPneb"};